const TradeBoxes = ({
    children,
    headerName,
    classNames: { parentDiv, header, content },
    styles,
    icon
}) => {
    return (
        <div className={parentDiv} style={styles?.parentDiv}>
            <div className={header} style={styles?.header}>
                {headerName}
                {icon}
            </div>
            <div className={content} style={styles?.content}>
                {children}
            </div>
        </div>
    );
};

export default TradeBoxes;
